import { render, staticRenderFns } from "./TipTapWrapper.vue?vue&type=template&id=45bb0a20&"
import script from "./TipTapWrapper.vue?vue&type=script&lang=ts&"
export * from "./TipTapWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./TipTapWrapper.vue?vue&type=style&index=0&id=45bb0a20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports